import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function Memory() {
    useEffect(() => {
        document.title = 'КьюАй - Суперпамять';
    }, [])

    return <>
        <div>
            Родителям, предлагаем вашим детям обучение на курсе Суперпамять в центре детского развития КьюАй.
            Это авторская программа, состоящая из 12 уроков-путешествий в страну Мнемоники. На каждом занятии
            ваш ребенок будет изучать новые способы запоминания, используя фантазию и воображение. Уроки
            представлены в интерактивном формате с интересными материалами и пособиями. Этот курс поможет вашему
            ребенку не только улучшить школьные оценки, но и сделает его память более эффективной в повседневной
            жизни.

        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Развитие навыка памяти списков простых и сложных слов, картинки и числа;</li>
                    <li>Умение запоминать последовательности слов и их порядковых номеров;</li>
                    <li>Запоминание имен великих людей и их биографии;</li>
                    <li>Усвоение математических формул, таблицы Менделеева и т.д.;</li>
                    <li>Закрепление в памяти исторических событий и их дат;</li>
                    <li>Освоение иностранных слов без заучивания;</li>
                    <li>Долговременное хранение в памяти названия стран и их столиц;</li>
                    <li>Запоминание стихов и текстов через фантазию без особых усилий;</li>
                    <li>Закрепление в памяти телефонов и дат рождения.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-cp"></div>
            </div>
        </div>
        <div>
            После прохождения курса Суперпамять у ребят наблюдаются отличные результаты: запоминание улучшается
            в разы, развивается способность закрепления в памяти информации на длительный срок растет, а также
            увеличивается скорость вспоминания. Курс Суперпамять помогает детям запоминать все виды информации,
            от слов и чисел до исторических дат и событий, имен великих людей, математических формул и
            иностранных слов. Центр детского развития КьюАй дает ребенку возможность не только улучшить память,
            но и инструменты для дальнейшего саморазвития.

        </div>
        <div>
            Родители, дайте своим детям возможность развить свою память и стать успешными в учебе и жизни! Не
            упустите эту возможность и запишите ваших детей на курс Суперпамять от центра детского развития
            КьюАй уже сегодня!

        </div>
    </>
}